import React, { createContext, useState, useEffect } from "react";

import { Column } from "./export";

interface Props {
  children?: React.ReactNode;
  columns: Column[];
  onChangeColumns?: (columns: string[]) => void;
}

interface ContextData {
  selectedColumns: number[];
  setColumns: Function;
  cellSizes?: CellSizes;
  rowSizes?: RowSizes;
  headerHeight: number | undefined;
  setHeaderHeight: React.Dispatch<React.SetStateAction<number | undefined>>;
  setCellSizes: React.Dispatch<React.SetStateAction<CellSizes | undefined>>;
  handleSetRowSizes: (index: number, value: number) => void;
}

type CellSizes = {
  [index: string]: {
    width: number;
    height: number;
  };
};

type RowSizes = {
  [index: number]: number;
};

const Context = createContext<ContextData>({} as ContextData);

export const ContextProvider = ({ children, columns, onChangeColumns }: Props) => {
  const [selectedColumns, setColumnsState] = useState<number[]>(
    columns.map((column, index) => {
      if (column.initialHideColumn) return -1;

      return index;
    })
  );
  const [cellSizes, setCellSizes] = useState<CellSizes>();
  const [rowSizes, setRowSizes] = useState<RowSizes>();
  const [headerHeight, setHeaderHeight] = useState<number>();

  const handleSetRowSizes = (index: number, value: number) => {
    setRowSizes((prev) => {
      return {
        ...prev,
        [index]: value,
      };
    });
  };

  const setColumns = (chosedColumns: number[]) => {
    setColumnsState(chosedColumns);
    onChangeColumns?.(
      columns.reduce((filtered, column, index) => {
        if (chosedColumns.includes(index)) {
          filtered.push(column?.key || column?.name);
        }

        return filtered;
      }, [] as string[])
    );
  };

  return (
    <Context.Provider
      value={{
        selectedColumns,
        cellSizes,
        rowSizes,
        headerHeight,
        setColumns,
        setCellSizes,
        handleSetRowSizes,
        setHeaderHeight,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
